const handleLogin = require("./handleLogin");

module.exports = async function login(e, authContext, path) {
	if (typeof e !== "undefined") {
		/**
		 * regular username/password login
		 */
		e.preventDefault();
		let loggedIn = await handleLogin(authContext, e);
		return loggedIn;
	} else if (typeof window !== "undefined") {
		/**
		 * auth0 login
		 */
		const loginUrl = new URL(process.env.CLF_BACKEND_URL);
		loginUrl.pathname = "/user/login";
		path && window.sessionStorage.setItem("cloverleaf_login_return_redirect", path);
		window.location.replace(loginUrl.toString());
	}
};
